import { gql } from "@apollo/client";

export default gql`
  fragment ProgramParticipantUpdates on ProgramAppliesToUpdatesNode {
    hasUpdates
    usersToAdd {
      id
      email
      name
      avatar
      currentRoles {
        id
        title
        level
      }
    }
    usersToRemove {
      id
      email
      name
      avatar
      currentRoles {
        id
        title
      }
    }
    rolesToChange {
      user {
        id
        name
        email
        avatar
        currentRoles {
          id
          title
        }
      }
      oldRoles {
        id
        title
      }
    }
    managersToChange {
      user {
        id
        name
        email
        avatar
      }
      oldManagers {
        id
        name
      }
      newManagers {
        id
        name
      }
    }
  }
  query getComplianceProgramAvailableAppliesToUpdates(
    $complianceProgramId: Int!
  ) {
    complianceProgram(pk: $complianceProgramId) {
      id
      availableAppliesToUpdates {
        ...ProgramParticipantUpdates
      }
    }
  }
`;
